// src/api/anonClient.js
import { computeFingerprintHash } from "../utils/fingerprint";

// CRA: REACT_APP_API_URL / Vite: VITE_API_URL
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

let FP_CACHE = null;
async function getFP() {
  if (FP_CACHE) return FP_CACHE;
  FP_CACHE = await computeFingerprintHash();
  return FP_CACHE;
}

export async function initAnonymous() {
  const anonId = localStorage.getItem("anon_id") || "";
  const fp = await getFP();

  const res = await fetch(`${API_BASE}/anon/init`, {
    method: "POST",
    credentials: "include", // httpOnly 쿠키 수신
    headers: {
      "Content-Type": "application/json",
      "X-Anonymous-ID": anonId,
      "X-Fingerprint": fp,
    },
  });
  if (!res.ok) throw new Error("anon init failed");
  const data = await res.json();
  if (data?.anon_id) {
    localStorage.setItem("anon_id", data.anon_id);
    return data.anon_id;
  }
  throw new Error("anon_id missing");
}

// 매 요청에 붙일 공통 옵션
export async function withAnon(init = {}) {
  const headers = new Headers(init.headers || {});
  headers.set("X-Anonymous-ID", localStorage.getItem("anon_id") || "");
  headers.set("Content-Type", headers.get("Content-Type") || "application/json");
  const fp = await getFP();
  headers.set("X-Fingerprint", fp);

  return { ...init, headers, credentials: "include" };
}
